export const EVENTS_ENUM = {
  UPDATE_BALANCE: 'update_balance',
  UNNAMED: 'unnamed',
}
